import { Market } from "../../models/Market";
import { Selection } from "../../models";

export class OddsHelper {

    public static convertMarketOdds(markets: Market[], oddsUtil: Odds, branchID: string): void {
        let selection: Selection;
        let marketKeys = Object.keys(markets);
        for (let index = 0; index < marketKeys.length; index += 1) {
            let market = markets[marketKeys[index]];
            for (let index = 0; index < market.selections.length; index += 1) {
                selection = market.selections[index];

                if (selection.odds !== 0 && !isNaN(selection.odds))
                {
                    let convertedOdds: any = (oddsUtil.convertFormat(selection.odds, parseInt(market.typeID), selection.lineType,
                        undefined, 1, undefined, parseInt(branchID)));
                    isNaN(convertedOdds) ? "" : selection.odds = convertedOdds;
                }
                else
                {
                    selection.odds = NaN;
                }
            }
        }
    }
}
